import React from 'react';
import PropTypes from 'prop-types';
import authHelper from 'helpers/auth';
import Actions from 'components/ui/general/Actions';
import ActiveStateButton from 'components/button/ActiveStateButton';
import AddButton from 'components/button/AddButton';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Column from 'components/ui/show/Column';
import ConfirmButton from 'components/button/ConfirmButton';
import EditButton from 'components/button/EditButton';
import FullNameTextField from 'components/show/FullNameTextField';
import Header from 'components/ui/general/Header';
import InnerColumn from 'components/ui/show/InnerColumn';
import languageHelper from 'helpers/languages';
import Notification from 'components/ui/general/Notification';
import ResetPasswordButton from 'components/button/ResetPasswordButton';
import Section from 'components/ui/general/Section';
import TextField from 'components/show/TextField';
import Title from 'components/ui/general/Title';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import UserNotActiveNotification from 'components/notifications/UserNotActiveNotification';
import UserNotConfirmedNotification from 'components/notifications/UserNotConfirmedNotification';
import { ImageIcon, RefreshIcon } from 'assets/materialIcons/materialIcons';
import { updateUserActivityFailure, updateUserActivitySuccess, updateUserConfirmationFailure, updateUserConfirmationSuccess } from 'store/actions/users/updateUsers';
import UserWalletsListContainer from 'pages/users/wallets/UserWalletsListContainer';
import ActionButton from 'components/button/ActionButton';
import UserProductMemberhipsListContainer from '../product-memberships/UserProductMemberhipsListContainer';
import InvoicesTable from 'pages/invoices/list/InvoicesTable';

const UsersShow = (props) => {
    const {
        history,
        id,
        loadingWallets,
        record,
        refreshWallets,
        resource,
        translate,
        wallets,
    } = props;

    const fullName = utils.fullName(record.first_name, record.last_name);

    const isAdmin = authHelper.isAdmin();

    const breadcrumbs = [
        {
            label: translate('resources.users.title'),
            link: '/users',
        },
        {
            label: fullName,
        },
    ];

    return (
        <div>
            <Breadcrumbs breadcrumbs={ breadcrumbs } />

            <Header>
                <Title title={ `${ fullName } (${ record.id })` } />

                <Actions>
                    {(isAdmin && !record.is_confirmed) &&
                        <ConfirmButton
                            failureAction={ updateUserConfirmationFailure }
                            record={ record }
                            resource='users'
                            successAction={ updateUserConfirmationSuccess }
                        />
                    }

                    {record.is_confirmed && !record.is_enabled &&
                        <ActiveStateButton
                            active={ record.is_enabled }
                            failureAction={ updateUserActivityFailure }
                            id={ record.id }
                            resource='users'
                            successAction={ updateUserActivitySuccess }
                        />
                    }

                    <ResetPasswordButton
                        id={ record.id }
                    />

                    <EditButton
                        icon={ <ImageIcon color={ theme.palette.doveGray } /> }
                        primary={ false }
                        record={ record }
                        url={ `/${ resource }/${ record.id }` }
                    />
                </Actions>
            </Header>

            <Notification>
                <UserNotActiveNotification
                    data={ record }
                    resource={ resource }
                />
                <UserNotConfirmedNotification
                    data={ record }
                    resource={ resource }
                />
            </Notification>

            <Section>
                <Column title={ translate('resources.users.forms.general') }>
                    <InnerColumn>
                        <FullNameTextField
                            data={ record }
                            label='resources.users.fields.name'
                        />

                        <TextField
                            label='resources.users.fields.locale'
                            value={ translate(`languages.${ languageHelper.getLabel(record.locale).toLowerCase() }`) }
                        />
                    </InnerColumn>
                </Column>
            </Section>

            <Section>
                <Column title={ translate('resources.users.forms.contact') }>
                    <InnerColumn>
                        <TextField
                            label='resources.users.fields.email'
                            value={ record.email }
                        />

                        <TextField
                            label='resources.users.fields.phonenumber'
                            value={ record.phone }
                        />
                    </InnerColumn>
                </Column>
            </Section>

            <Section>
                <Column
                    actions={
                        <Actions>
                            <ActionButton icon={ <RefreshIcon /> } onClick={ refreshWallets } title={ translate('actions.refresh') } />
                            <AddButton basePath={ `users/${ id }/wallets` } />
                        </Actions>
                    }
                    title={ translate('resources.wallets.title') }
                >
                    <InnerColumn>
                        <UserWalletsListContainer
                            loadingWallets={ loadingWallets }
                            refreshWallets={ refreshWallets }
                            wallets={ wallets }
                        />
                    </InnerColumn>
                </Column>
            </Section>

            <Section>
                <Column
                    actions={
                        <AddButton basePath={ `users/${ id }/product-memberships` } />
                    }
                    title={ translate('menu.sidebar.product_memberships') }
                >
                    <InnerColumn>
                        <UserProductMemberhipsListContainer
                            userId={ id }
                        />
                    </InnerColumn>
                </Column>
            </Section>
            <Section>
                <Column
                    title={ translate('menu.sidebar.invoices') }
                >
                    <InnerColumn>
                        <InvoicesTable
                            history={ history }
                            params={ { user_id: id } }
                        />
                    </InnerColumn>
                </Column>
            </Section>
        </div>
    );

};

UsersShow.propTypes = {
    history: PropTypes.object.isRequired,
    id: PropTypes.number.isRequired,
    loadingWallets: PropTypes.bool,
    record: PropTypes.shape({
        email: PropTypes.string,
        first_name: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        is_confirmed: PropTypes.bool.isRequired,
        is_enabled: PropTypes.bool.isRequired,
        last_name: PropTypes.string.isRequired,
        locale: PropTypes.string.isRequired,
        phone: PropTypes.string.isRequired,
    }).isRequired,
    refreshWallets: PropTypes.func.isRequired,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    wallets: PropTypes.arrayOf(PropTypes.shape({
        balance: PropTypes.number,
        currency: PropTypes.string,
        id: PropTypes.number,
    })).isRequired,
};

export default translate(UsersShow);



// WEBPACK FOOTER //
// ./src/pages/users/show/UsersShow.js